import { router } from "expo-router"
import { View } from "react-native"
import { TouchableOpacity } from "react-native-gesture-handler"
import CloseButton from "@/assets/icons/white-close-button.svg"
import { useSafeAreaInsets } from "react-native-safe-area-context"
import { useViewedCallback } from "@/analytics/react"
import { setStatusBarStyle } from "@/stores/statusBarStyle"
import BFText from "@/components/standard/BFText"

export default function StreetViewScreen() {
  const insets = useSafeAreaInsets()

  useViewedCallback(() => {
    setStatusBarStyle("light")
  })

  return (
    <View className="flex flex-1">
      <View className="flex flex-row items-center justify-center m-auto">
        <BFText className="font-figtree-bold">
          Street View Unavailable on web
        </BFText>
      </View>
      <View className="absolute right-6" style={{ top: insets.top + 32 }}>
        <TouchableOpacity
          testID={"close-button"}
          onPress={() => {
            router.push("../")
          }}
          hitSlop={12}
        >
          <CloseButton width={40} height={40} />
        </TouchableOpacity>
      </View>
    </View>
  )
}
